<style scoped>
.task {
	box-shadow: 2px 2px 4px gray;
	background-color: white;
	border-radius: 5px;
	margin-left: 5px;
	margin-right: 5px;
	margin-bottom: 5px;
}

.task_top {
	background-color: #FFD029;
	border-radius: 5px 5px 0px 0px;
	width: 100%;
	height: 5px;
}

.task_title {
	font-size: 16px;
	color: black;
	overflow: hidden;
}
</style>

<template>
	<div class="task" :color="recording_task_id == task.id ? 'rgb(200, 255, 200)' : 'white'" @click.prevent="do_click()">
		<div class="task_top"/>
		<div class="px-3 py-1">
			<v-row no-gutters>
				<v-col cols="2" class="pt-1">
					<task_icon 
						style="float:left;position: relative;top: 15px; left: 5px;"
						:recording="recording_task_id == task.id" 
						:status_type="task.status.type" 
						:active="recording_task_id == 0"
						@start="do_start()"
						@stop="do_stop()"
					/>
				</v-col>
				<v-col cols="10"  class="pt-1">
					<div class="task_title">
						{{ task.title }}
					</div>
					<div class="text-caption mt-1">
						{{ task.job.code }} - {{ task.job.name }}
					</div>
					<div class="text-caption">
						{{ task.client.name }}
					</div>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col :cols="task.start_time.length !== 0 ? 4 : 6" class="text-caption pl-1 mt-1">
					<div>Logged {{ actual }}</div>
				</v-col>
				<v-col v-if="task.start_time.length !== 0" cols="5" class="text-caption pl-1 mt-1">
					<div>Start&nbsp;{{ task.start_time }}</div>
				</v-col>
				<v-col :cols="task.start_time.length !== 0 ? 3 : 6" class="text-caption pr-1 mt-1">
					<div 
						v-if="task.budget != 0" 
						style="float: right"
					>
						Budget {{ budget }}
					</div>
					<div 
						style="float: right" 
						v-if="task.budget == 0"
					>
						No budget
					</div>
				</v-col>
			</v-row>
		</div>
		<budget_used :used="budget_used"/>
	</div>
</template>

<script>
import task_icon from "@/components/tasks/task_icon"
import budget_used from "@/components/tasks/budget_used"
import { durationMixin } from "@/mixins/misc/durationMixin"
// import grab_icon from "@/components/icons/grab";
// import down_icon from "@/components/icons/down"

export default {
	mixins: [ durationMixin ],
	props: {
		task: {
			type: Object,
			default: null
		},
		recording: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			test: false
		}
	},
	computed: {
		recording_task_id: function() {
			return this.$store.state.recording.task_id;
		},

		budget() {
			if (this.task == null) {
				return 'n/a';
			} else {
				return this.format_duration(this.task.budget);
				
			}
		},
		actual: function() {
			if (this.task == null) {
				return 'none';
			} else if (this.task.actual == 0) {
				return 'none';				
			} else {
				return this.format_duration(this.task.actual);
			}
		},
		budget_used: function() {
			if (this.task == null) {
				return 0;
			} else {
				return this.task.budget_used;
			}
		},
	},
	methods: {
		do_click: function() {
			this.$emit('click', this.task.id)
		},
		do_start: function() {
			this.$store.dispatch('start_recording', { task_id: this.task.id, started: new Date().getTime() })
		},
		do_stop: function() {
			this.$emit('stop_recording')
		},
	},
	components: {
		task_icon, budget_used
		// , grab_icon, down_icon
	}
}
</script>